import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCustomerSupport = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.987 3.75a4.69 4.69 0 0 0-4.775 4.614v6.405a1.44 1.44 0 0 1-1.443 1.442H4.385a2.135 2.135 0 0 1-2.135-2.134v-2.77a2.135 2.135 0 0 1 2.135-2.134h1.327v-.826A6.19 6.19 0 0 1 12 2.25a6.19 6.19 0 0 1 6.288 6.097v.826h1.327a2.135 2.135 0 0 1 2.135 2.135v2.769a2.135 2.135 0 0 1-2.135 2.134H18.29v.289a3.52 3.52 0 0 1-2.867 3.458 2.48 2.48 0 0 1-2.383 1.792h-2.077a2.48 2.48 0 0 1 0-4.962h2.077a2.48 2.48 0 0 1 2.333 1.639 2.02 2.02 0 0 0 1.416-1.927V8.364a4.69 4.69 0 0 0-4.774-4.614zm2.032 15.509a.98.98 0 0 0-.98-.97h-2.077a.98.98 0 0 0 0 1.96h2.077a.98.98 0 0 0 .98-.97v-.02m5.596-4.548H18.29v-4.038h1.326a.634.634 0 0 1 .635.635v2.769a.635.635 0 0 1-.635.634M5.712 12v-1.327H4.385a.635.635 0 0 0-.635.635v2.769a.634.634 0 0 0 .635.634h1.327V12"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCustomerSupport;
